export async function importSwiper() {
    const {default: Swiper} = await import('swiper')
    const {Navigation, Autoplay} = await import('swiper/modules')
    return {Swiper, Navigation, Autoplay}
}

export async function importModalVideo() {
    const {default: ModalVideo} = await import('modal-video')
    return ModalVideo
}

export async function importLazyFrame() {
    const {default: lazyframe} = await import('lazyframe')
    return lazyframe
}

export async function importGoogleLoader() {
    const {Loader} = await import('@googlemaps/js-api-loader')
    return Loader
}

export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function updateHeaderHeight() {
    const header = document.querySelector('header.site-header')
    const height = header.getBoundingClientRect().height
    const root = document.querySelector(':root')
    root.style.setProperty('--kp-header-height', `${height}px`);
}

export function allowScrolling(allow) {
    const els = [document.documentElement, document.body]
    if (!allow) {
        document.body.dataset.scrollPos = window.scrollY
    }
    els.forEach(el => {
        el.classList.toggle('m-0', !allow)
        el.classList.toggle('h-screen', !allow)
        el.classList.toggle('overflow-hidden', !allow)

        if (!allow) {
            el.scrollTop = parseInt(document.body.dataset.scrollPos)
        }
    })
    if (allow) {
        window.scrollTo({
            top: parseInt(document.body.dataset.scrollPos),
            behavior: 'instant'
        })
    }
}